import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import { VuiAccordion, VuiSettingsRow, VuiLoader } from '@topkamera/viso-ui'
import { mapNoticationPermissions, updatePermissionValue } from '../utils.js'
import { getNotificationPermissions } from 'api/notifications'
import { getAuthNotificationPermissions } from 'api/auth'
import { handleApiResponse } from 'utils/request'
import { defaultNotifier } from 'functions/notificationHandler'
import './NotificationSettings.scss'

const NotificationSettings = ({
  setValues, setUntouchedValues, toggleTouched, values, permissionsId, color, hideIntro, noWrapperStyle
}) => {
  const [isLoading, toggleLoading] = useState(true)
  const [permissionsData, setPermissionsData] = useState([])

  const mapPermissions = (response) => {
    const mapResponse = mapNoticationPermissions(response, permissionsId, color)
    setPermissionsData(mapResponse)
  }

  const getData = async () => {
    toggleLoading(true)
    const onSuccess = (response) => {
      setValues(response)
      setUntouchedValues?.(response)
      mapPermissions(response)
    }

    try {
      let settingsResponse
      if (permissionsId) {
        settingsResponse = await getAuthNotificationPermissions({ id: permissionsId })
      } else {
        settingsResponse = await getNotificationPermissions()
      }
      handleApiResponse(settingsResponse, onSuccess, 'notificationPermissions')
    } catch (error) {
      setPermissionsData([])
      defaultNotifier(error)
    } finally {
      toggleLoading(false)
    }
  }

  useEffect(() => { getData() }, [permissionsId])
  useEffect(() => { mapPermissions(values) }, [values])

  const onInputChange = (input, value) => {
    toggleTouched(true)
    const updatedPermissions = updatePermissionValue(input.id, value, values)
    const updatedValues = permissionsData.map(section => ({
      ...section, rows: section.rows.map(row => ({
        ...row, inputs: row.inputs.map(inp => {
          if (inp.inputProps.id !== input.id) { return inp }
          return { ...inp, inputProps: { ...inp.inputProps, checked: value } }
        })
      }))
    }))
    setPermissionsData(updatedValues)
    setValues(updatedPermissions)
  }

  return (
    <div className={classNames('vui-flex vui-flex-column vui-gap-40', !noWrapperStyle && 'viso-notification-settings')}>
      {!hideIntro && <div className='vui-body-sm'>Choose where each alert appears. Locked items are set by your workspace.</div>}
      {isLoading ? <VuiLoader type='dots' /> :
        <div className='viso-notification-accordion'>
          <VuiAccordion
            defaultOpenIndex={0}
            style='section'
            items={permissionsData.length > 0 ? permissionsData.map((item) => {
              return {
                title: <VuiSettingsRow headers={item.headers} />,
                content: <VuiSettingsRow rows={item.rows} onChange={onInputChange} />
              }
            }) : []}
          />
        </div>
      }
    </div>
  )
}

export default NotificationSettings